import type {
  RouteLocationNamedRaw,
  RouteLocationNormalized,
  RouteLocationPathRaw,
  RouteLocationRaw,
} from 'vue-router';

type Query = RouteLocationNormalized['query'];

const AUTHENTICATION_QUERY_PARAMS_BLACKLIST = ['code', 'state', 'session_state'];

function sanitizeAuthenticatedQuery(query: Query): Query {
  return Object.entries(query).reduce<Query>((acc, [key, value]) => {
    if (!AUTHENTICATION_QUERY_PARAMS_BLACKLIST.includes(key)) {
      acc[key] = value;
    }

    return acc;
  }, {});
}

export function sanitizeAuthenticatedRoute(route: RouteLocationNormalized): RouteLocationRaw | undefined {
  if (AUTHENTICATION_QUERY_PARAMS_BLACKLIST.every(key => !!route.query[key])) {
    const { name, path, params, query, hash } = route;

    if (name) {
      const routeLocationNamedRaw: RouteLocationNamedRaw = {
        name: name,
        params,
        query: sanitizeAuthenticatedQuery(query),
        hash,
      };

      return routeLocationNamedRaw;
    } else {
      const routeLocationPathRaw: RouteLocationPathRaw = {
        path,
        query: sanitizeAuthenticatedQuery(query),
        hash,
      };

      return routeLocationPathRaw;
    }
  }

  return;
}
